import theme from '@travelnest/merlin.theme';
import React from 'react';
import { IPromotionOpportunity } from '../../../data/entities/promotions';
import { PromotionItem } from './PromotionsItem';

export interface IChannelPromotion {
	id: string;
	name: string;
	imageURL?: string;
	promotions: IPromotionOpportunity[];
}

export const PromotionsChannelList: React.FC<{
	channelPromotion: IChannelPromotion;
	onSelectPromotion: (promotion: IPromotionOpportunity) => void;
}> = ({ channelPromotion, onSelectPromotion }) => {
	const { name, promotions, imageURL } = channelPromotion;

	return (
		<div >
			<div
				style={{
					display: 'flex',
					flexDirection: 'row',
					alignItems: 'center',
					width: '100%',
					borderBottom: `1px solid ${theme.colours.neutral.light}`,
				}}
			>
				<div>
					{imageURL ? (
						<img src={imageURL} style={{ width: '50px' }} />
					) : null}
				</div>
				<div style={{ paddingLeft: '10px' }}>{name}</div>
			</div>
			<div style={{ paddingTop: '10px' }}>
				{promotions.map((promo) => (
					<PromotionItem
						key={promo.internal_reference}
						promotion={promo}
						onSelectPromotion={onSelectPromotion}
					/>
				))}
			</div>
		</div>
	);
};
